import HubspotForm from "../utils/hubspot-form";
import { publicConfig } from "../config";

const { HUBSPOT_PORTAL_ID, HUBSPOT_VIEWER_FORM_ID } = publicConfig;

export const ViewerForm = HubspotForm(HUBSPOT_PORTAL_ID, HUBSPOT_VIEWER_FORM_ID);
